import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  DictionaryAssetDeliveryStatus,
  DictionaryContractType,
} from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { AssetDeliveryDelegateModalComponent } from 'src/app/features/my-assets/asset-modals/asset-delivery-delegate-modal/asset-delivery-delegate-modal.component';

@Component({
  selector: 'contract-detail-assets',
  templateUrl: './contract-detail-assets.component.html',
  styleUrls: ['./contract-detail-assets.component.scss'],
  standalone: false,
})
export class ContractDetailAssetsComponent {
  public constructor(
    private _router: Router,
    private _ngbModal: NgbModal
  ) {}

  @Input() assets: app.models.ContractDetailAssetModel[];
  @Input() requestAccessWarnings: string[] = [];
  @Input() props: app.models.DynamicPropsDictionary;
  @Input() contract: app.models.ContractDetailModel;

  ContractType = DictionaryContractType;
  AssetDeliveryStatus = DictionaryAssetDeliveryStatus;

  redirectDocumentRequest(contractId: string, assetId: string) {
    this._router.navigate(['requests/new', contractId, assetId]);
  }

  openDelegateModal(asset: app.models.ContractDetailAssetModel) {
    const assetModel = {
      assetId: asset.assetId,
      deliveryDelegateId: asset.deliveryDelegateId,
      deliveryDelegateName: asset.deliveryDelegateName,
    } as app.models.AssetListModel;

    const modalRef = this._ngbModal.open(AssetDeliveryDelegateModalComponent, {
      scrollable: true,
    });
    modalRef.componentInstance.asset = assetModel;

    modalRef.result.then(result => {
      if (!result || (result as app.models.Delegate) == null) {
        return;
      }

      asset.deliveryDelegateId = result?.delegateId;
      asset.deliveryDelegateName = result?.firstName + ' ' + result?.lastName;
    });
  }

  isNumeric(value: string): boolean {
    return value.trim() !== '' && !isNaN(Number(value));
  }
}
